import React, { useState, useEffect } from "react";
import imgParticulier from "../../img/occ-p.png";
import imgDealer from "../../img/occ-d.png";
import "./OccasionOptions.css";
import { t } from "i18next";

const OccasionOptions = ({ inputData, setInputData }) => {
  const options = [
    {
      label: "PARTICULIER",
      text: t("VanEenParticulier"),
      selected: false,
      available: true,
      img: imgParticulier,
    },
    {
      label: "DEALER",
      text: t("VanEenBedrijf"),
      selected: false,
      available: true,
      img: imgDealer,
    },
  ];

  console.log(inputData)

  return (
    <div className="occasion-cards">
      {options.map((option, index) => (
        <div
          key={index}
          className={`occasion-card ${
            inputData?.purchaseType === option.label ? "selected" : ""
          } ${option.available === false ? "not-available" : ""}`}
          onClick={() => {
            setInputData({ ...inputData, purchaseType: option.label })
          }}
        >
          <img src={option.img} alt={option.label} />
          <h3>{option.text}</h3>
        </div>
      ))}
    </div>
  );
};

export default OccasionOptions;
